
import SendButton from './send-button.vue'
import InputRecorder from './input-recorder.vue'

export default {
  components: {InputRecorder, SendButton},
  props: {
    canPush: {type: Boolean, default: false},
    generating: {type: Boolean, default: false},
  },
  emits: ['push', 'stop', 'transcribed']
}
